<ifc-app-scroll-container [widgetsWithTopHeader]="true">

  <div class="layout margin flex-std"
       [@routerTransition]="'fly'">

    <div class="layout padding-sm"
         fxLayout.gt-md="row"
         fxLayout="column"
         fxLayoutAlign.gt-md="center start"
         fxLayoutAlign="center center"
         fxFlex="100"
         fxLayoutGap="24px">

      <div fxLayout="column"
           fxLayoutGap="24px"
           fxLayoutAlign.xs="center center">
        <ifb-card>
          <ifc-simple-horizontal-list-widget title="Status and activation"
                                             [listItems]="statusListItems"
                                             [config]="{ isEditable: canEditBrokerInfo }"
                                             (edit)="onEditStatus()">
          </ifc-simple-horizontal-list-widget>
          <ifc-simple-horizontal-list-widget title="Commission info"
                                             [listItems]="commissionListItems"
                                             [config]="{ isEditable: canEditBrokerInfo }"
                                             (edit)="onEditCommission()">
          </ifc-simple-horizontal-list-widget>
        </ifb-card>
      </div>

      <div fxLayout="column"
           fxLayoutGap="24px"
           fxLayoutAlign.xs="center center">
        <ifb-card>
          <ifb-broker-company-widget [broker]="data?.broker"
                                     [edit]="canEditBrokerInfo">
          </ifb-broker-company-widget>
          <ifc-simple-horizontal-list-widget title="Branding"
                                             [listItems]="brandingListItems">
          </ifc-simple-horizontal-list-widget>
        </ifb-card>
      </div>

      <div fxLayout="column"
           fxLayoutGap="24px"
           fxLayoutAlign.xs="center center">
        <ifb-card>
          <ifc-simple-horizontal-list-widget title="Other info"
                                             [listItems]="otherInfoListItems"
                                             [config]="{ isEditable: canEditBrokerInfo }"
                                             (edit)="onEditOtherInfo()">
          </ifc-simple-horizontal-list-widget>
          <ifb-business-advisor-widget [data]="advisorData"
                                       [teamContactEmail]="data?.broker?.teamContactEmail"
                                       [canEditAdvisor]="canEditBrokerInfo"
                                       (edit)="changeAdvisor()">
          </ifb-business-advisor-widget>
          <ifc-simple-horizontal-list-widget title="Broker Activity"
                                             [listItems]="brokerActivityListItems">
          </ifc-simple-horizontal-list-widget>
          <ifb-broker-api-widget [broker]="data?.broker"
                                 [canEdit]="canEditBrokerInfo"
                                 (edit)="changeApiEnabled($event)">
          </ifb-broker-api-widget>
        </ifb-card>
      </div>
    </div>
  </div>

</ifc-app-scroll-container>
